// extracted by mini-css-extract-plugin
export default {"summaryContainer":"DisplaySummary_summaryContainer__LedKv","textContainer":"DisplaySummary_textContainer__0-C8-","summaryText":"DisplaySummary_summaryText__b2Ddf"};